export default __webpack_public_path__ + "static/media/P-006.c555da65.png";